import { render, staticRenderFns } from "./ReferralInviteeBanner.vue?vue&type=template&id=6a4cd396&scoped=true"
import script from "./ReferralInviteeBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReferralInviteeBanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReferralInviteeBanner.vue?vue&type=style&index=0&id=6a4cd396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4cd396",
  null
  
)

export default component.exports